import { trpc } from "@/lib/trpc";

export default function CmsContactHeroDescription() {
  const content = trpc.cms.public.content.useQuery();
  return content.data?.["contact.hero.description"] || "Sklep stacjonarny w Sławnie. Zadzwoń, napisz lub odwiedź nas osobiście";
}
